import { ColorEnum } from '@/constants/color'
import { FontEnum } from '@/constants/font'
import { useScreenOrientation, useScreenSize } from '@/hooks/screen'
import { FC } from 'react'
import { StyleProp, StyleSheet, Text, View, ViewStyle } from 'react-native'

interface TitleWithHintProps {
    title: string
    hint: string
    style?: StyleProp<ViewStyle>
}

const TitleWithHint: FC<TitleWithHintProps> = ({ title, hint, style }) => {
    const screenSize = useScreenSize()
    const screenOrientation = useScreenOrientation()

    const marginTop = screenSize === 'small' && screenOrientation === 'landscape' ? 15 : 30

    const titleStyle = {
        fontSize: screenSize === 'small' ? 18 : 23,
    }

    const hintStyle = {
        fontSize: screenSize === 'small' ? 14 : 16,
    }

    return (
        <View style={[styles.container, { marginTop }, style]}>
            <Text style={[styles.title, titleStyle]}>{title}</Text>
            <Text style={[styles.hint, hintStyle]}>{hint}</Text>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        gap: 8,
    },
    title: {
        color: ColorEnum.WHITE,
        fontFamily: FontEnum.SatoshiBold,
        textTransform: 'uppercase',
    },
    hint: {
        color: ColorEnum.WHITE,
        fontFamily: FontEnum.SatoshiLight,
        textAlign: 'center',
    },
})

export default TitleWithHint
